// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BRibyg {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
}

.bPkGYE {
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-2, 16px);
}

.R2bHj1 {
  flex-direction: row;
  display: flex;
  align-items: start;
  gap: var(--spacing-1-5, 12px);
}

.gxNi9J {
  margin-top: 6px;
}

.clGNgS {
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  color: var(--text-neutral-dark);
}

.V3_zEE {
  display: flex;
  flex-direction: column;
}

.FsT9bS {
  padding: var(--spacing-1-5);
}

.uV2A8s {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
}

.Ae320S {
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-1-5, 12px);
}

.k2w4We {
  font-size: var(--font-size-lg, 16px);
  font-weight: var(--font-weight-semibold, 600);
  color: var(--text-neutral-dark);
}

.r9Ye85 {
  font-size: var(--font-size-s, 12px);
  font-weight: var(--font-weight-regular, 400);
  color: var(--text-neutral-dark);
}

.Nsh6hU {
  height: 1px;
  background-color: var(--border-neutral-light, #e5e5e5);
  margin: var(--spacing-2, 16px) 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DrawerOperator/pages/RegisterType/components/Item.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,sDAAsD;EACtD,gCAAgC;AAClC","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n}\n\n.description {\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-2, 16px);\n}\n\n.item {\n  flex-direction: row;\n  display: flex;\n  align-items: start;\n  gap: var(--spacing-1-5, 12px);\n}\n\n.icon {\n  margin-top: 6px;\n}\n\n.text {\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  color: var(--text-neutral-dark);\n}\n\n.customItems {\n  display: flex;\n  flex-direction: column;\n}\n\n.customInput {\n  padding: var(--spacing-1-5);\n}\n\n.itemContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n}\n\n.customItem {\n  flex-direction: row;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-1-5, 12px);\n}\n\n.customTitle {\n  font-size: var(--font-size-lg, 16px);\n  font-weight: var(--font-weight-semibold, 600);\n  color: var(--text-neutral-dark);\n}\n\n.customDesc {\n  font-size: var(--font-size-s, 12px);\n  font-weight: var(--font-weight-regular, 400);\n  color: var(--text-neutral-dark);\n}\n\n.itemDivider {\n  height: 1px;\n  background-color: var(--border-neutral-light, #e5e5e5);\n  margin: var(--spacing-2, 16px) 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BRibyg`,
	"description": `bPkGYE`,
	"item": `R2bHj1`,
	"icon": `gxNi9J`,
	"text": `clGNgS`,
	"customItems": `V3_zEE`,
	"customInput": `FsT9bS`,
	"itemContainer": `uV2A8s`,
	"customItem": `Ae320S`,
	"customTitle": `k2w4We`,
	"customDesc": `r9Ye85`,
	"itemDivider": `Nsh6hU`
};
module.exports = ___CSS_LOADER_EXPORT___;
